import { yourJourneySelectors } from '@store/yourJourney';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchFacilityTimeslot as fetchSpaEntityTimeSlot } from '@store/entity/actions';
import { formValueSelector } from 'redux-form';
import { guestSelectors } from '@store/guest/selectors';
import { basketSelectors } from '@store/basket/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { FacilityConfigWizard } from './FacilityConfigWizard';

const mapStateToProps = (state) => ({
  guest: guestSelectors.getGuest(state),
  isSpinnerVisible: basketSelectors.getIsBasketDetailsFetching(state),
  selectedTimeSlot: formValueSelector('spaEntityConfigurationForm')(state, 'arrivalTime'),
  spaPage: entitySelectors.getSpaPage(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSpaEntityTimeSlot,
    },
    dispatch
  );

export const FacilityConfigWizardContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(FacilityConfigWizard);
